import React from 'react';
import { SegmentedControl } from '../common/SegmentedControl';
import { floorCalendar } from '../../data/floorCalendar';
import type { FloorPreset } from '../../utils/floorRange';
const presets: {
  value: FloorPreset;
  label: string;
}[] = [{
  value: 'today',
  label: 'Today'
}, {
  value: 'yesterday',
  label: 'Yesterday'
}, {
  value: 'week',
  label: 'This week'
}, {
  value: 'custom',
  label: 'Custom'
}];
interface FloorRangePickerProps {
  preset: FloorPreset;
  onPresetChange: (p: FloorPreset) => void;
  custom: {
    start: string;
    end: string;
  };
  onCustomChange: (c: {
    start: string;
    end: string;
  }) => void;
}
const inputClass = 'rounded-xl border border-line bg-surface px-3 py-1.5 text-[13px] font-medium text-ink shadow-card transition-colors duration-150 ease-out hover:border-accent/30 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15';
export function FloorRangePicker({
  preset,
  onPresetChange,
  custom,
  onCustomChange
}: FloorRangePickerProps) {
  return <div className="flex flex-wrap items-center gap-3" data-id="element-186" data-mp="zq3wm53ogh3g">
      <SegmentedControl label="Date range" options={presets} value={preset} onChange={onPresetChange} data-id="element-187" data-mp="znhqm9wfq9nc" />
      {preset === 'custom' && <div className="flex items-center gap-2" data-id="element-188" data-mp="qoe754tcvs8b">
          <label className="flex items-center gap-2 text-xs text-muted" data-id="element-189" data-mp="qn2wqm5enm88">
            From
            <input type="date" value={custom.start} min={floorCalendar.min} max={floorCalendar.max} onChange={e => e.target.value && onCustomChange({
          ...custom,
          start: e.target.value
        })} className={inputClass} data-id="element-190" data-mp="lpkufelw8597" />
          </label>
          <label className="flex items-center gap-2 text-xs text-muted" data-id="element-191" data-mp="7w2044rrc2ru">
            To
            <input type="date" value={custom.end} min={floorCalendar.min} max={floorCalendar.max} onChange={e => e.target.value && onCustomChange({
          ...custom,
          end: e.target.value
        })} className={inputClass} data-id="element-192" data-mp="2x8l27wto3pk" />
          </label>
        </div>}
    </div>;
}